import type { WorkflowStatus } from "@entrilia/shared/api/workflowTypes";
import StatusChip from "@entrilia/shared/components/StatusChip";

interface Props {
  workflowStatus: WorkflowStatus;
  requiresUserAction?: boolean;
}

const WorkflowStatusTag = ({ workflowStatus, requiresUserAction }: Props) => {
  if (requiresUserAction) {
    return <StatusChip label="Needs Action" withDot color={(t) => t.palette.warning.main} />;
  }

  switch (workflowStatus) {
    case "InProgress":
      return <StatusChip label="Pending" withDot color={(t) => t.palette.info.main} />;
    case "Completed":
      return <StatusChip label="Completed" withDot color={(t) => t.palette.success.main} />;
    case "Rejected":
      return <StatusChip label="Rejected" withDot color={(t) => t.palette.error.main} />;
    case "Cancelled":
      return <StatusChip label="Canceled" withDot color={(t) => t.palette.text.secondary} />;
    case "Failed":
      return <StatusChip label="Failed" withDot color={(t) => t.palette.error.dark} />;
    default:
      return null;
  }
};

export default WorkflowStatusTag;
